import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "vis-top" }
const _hoisted_3 = { class: "vis-name" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"width":"25px","margin-left":"15px"} }
const _hoisted_6 = {
  key: 0,
  class: "fal fa-crosshairs"
}
const _hoisted_7 = { class: "vis-right-controls" }
const _hoisted_8 = { style: {"font":"monospace","font-size":"0.7em","margin-left":"10px","margin-top":"2px","color":"#aeaeae"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"white-space":"nowrap"} }
const _hoisted_12 = { class: "vis-btn" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "vis-btn" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  ref: "remoteContainer",
  class: "vis-content"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { style: {"white-space":"nowrap"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "vis-loading"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("loading ")
const _hoisted_23 = { class: "vis-right-controls" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "z-value" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "z-scale-controls" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-down" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_menu = _resolveComponent("imdex-menu")!
  const _component_RemoteRenderView = _resolveComponent("RemoteRenderView")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_select = _resolveComponent("imdex-select")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "v-container",
    onMousedown: _cache[25] || (_cache[25] = ($event: any) => (_ctx.panelStore.SET_ACTIVE_VISUALIZER(_ctx.id, _ctx.componentState.viewId))),
    class: "visualizer-container"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["active-overlay", { active: _ctx.activeView == _ctx.componentState.viewId }])
    }, null, 2),
    (_ctx.pickData && _ctx.activeView == _ctx.componentState.viewId && _ctx.showPickData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "pickDetails",
          innerHTML: _ctx.pickDetails,
          class: "pick-details"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.$data[_ctx.dataType]
        }, null, 8, _hoisted_4),
        _withDirectives(_createElementVNode("span", { style: {"display":"flex","align-items":"center","white-space":"nowrap"} }, _toDisplayString(_ctx.name), 513), [
          [_vShow, !_ctx.collapsed]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isPicking)
          ? (_openBlock(), _createElementBlock("i", _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.componentState.viewId ?? 0), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panelButtons, (btn, i) => {
          return (_openBlock(), _createBlock(_component_imdex_tooltip, {
            nudgeY: -10,
            key: i
          }, {
            activator: _withCtx((on) => [
              _createElementVNode("div", _mergeProps({
                onClick: btn.action
              }, _toHandlers(on), {
                class: [{ disabled: btn.disabled }, "vis-btn"]
              }), [
                _createElementVNode("img", {
                  src: _ctx.$data[btn.icon]
                }, null, 8, _hoisted_10)
              ], 16, _hoisted_9)
            ]),
            tooltip: _withCtx(() => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(btn.name), 1)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_imdex_menu, {
          value: _ctx.splitHMenu,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.splitHMenu) = $event))
        }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: _ctx.$data['split_h']
              }, null, 8, _hoisted_13)
            ])
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("div", {
              onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
              class: "folder-options-menu animated-fast"
            }, [
              _createElementVNode("ul", {
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("li", {
                  style: {"white-space":"nowrap"},
                  onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  class: _normalizeClass({
										disabled: _ctx.cantSplitH || _ctx.visualizers.length == 4
									}),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.splitH(false)))
                }, _toDisplayString(_ctx.$t("ssa.visualizer.3dView.newView")), 35),
                _createElementVNode("li", {
                  class: _normalizeClass({
										disabled: _ctx.cantSplitH || !_ctx.canClone || _ctx.visualizers.length == 4
									}),
                  onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.splitH(true)))
                }, _toDisplayString(_ctx.$t("ssa.visualizer.3dView.cloneView")), 35)
              ], 32)
            ], 32)
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_imdex_menu, {
          "y-offset": "20",
          value: _ctx.splitVMenu,
          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.splitVMenu) = $event))
        }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                src: _ctx.$data['split_v']
              }, null, 8, _hoisted_15)
            ])
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("div", {
              onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
              class: "folder-options-menu animated-fast"
            }, [
              _createElementVNode("ul", {
                onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("li", {
                  style: {"white-space":"nowrap"},
                  class: _normalizeClass({
										disabled: _ctx.cantSplit || _ctx.visualizers.length == 4
									}),
                  onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.splitV(false)))
                }, _toDisplayString(_ctx.$t("ssa.visualizer.3dView.newView")), 35),
                _createElementVNode("li", {
                  class: _normalizeClass({
										disabled: _ctx.cantSplit || !_ctx.canClone || _ctx.visualizers.length == 4
									}),
                  onMousedown: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.splitV(true)))
                }, _toDisplayString(_ctx.$t("ssa.visualizer.3dView.cloneView")), 35)
              ], 32)
            ], 32)
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", {
        class: _normalizeClass([{ hidden: !_ctx.isOver }, "vis-right-controls"])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentButtons, (btn, i) => {
          return (_openBlock(), _createBlock(_component_imdex_tooltip, {
            nudgeY: -10,
            key: i
          }, {
            activator: _withCtx((on) => [
              _createElementVNode("div", _mergeProps({
                onClick: btn.action
              }, _toHandlers(on), { class: "vis-btn" }), [
                _createElementVNode("img", {
                  src: _ctx.$data[btn.icon]
                }, null, 8, _hoisted_18)
              ], 16, _hoisted_17)
            ]),
            tooltip: _withCtx(() => [
              _createElementVNode("span", _hoisted_19, _toDisplayString(btn.name), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        onMousemove: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.mouseForOverlay && _ctx.mouseForOverlay(...args))),
        ref: "renderer",
        class: "remote-view"
      }, [
        _withDirectives(_createElementVNode("canvas", {
          class: _normalizeClass(["overlay", { 'mouse-interaction-on': _ctx.overlayOn }]),
          ref: "overlay",
          onMousedown: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.overlayPickDown && _ctx.overlayPickDown(...args))),
          onMousemove: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.overlayPickMove && _ctx.overlayPickMove(...args))),
          onMouseup: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.overlayPickUp && _ctx.overlayPickUp(...args))),
          onDblclick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.overlayDblClick && _ctx.overlayDblClick(...args))),
          onContextmenu: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"]))
        }, null, 34), [
          [_vShow, _ctx.overlayOn]
        ]),
        _createVNode(_component_RemoteRenderView, {
          client: _ctx.wsLink.client,
          viewId: _ctx.componentState.viewId,
          active: true,
          defaultSize: 1,
          activeSize: 3,
          onClick: _ctx.handleClick,
          pickingListener: _ctx.pickingListener,
          enablePicking: _ctx.enablePicking
        }, null, 8, ["client", "viewId", "onClick", "pickingListener", "enablePicking"]),
        _hoisted_20
      ], 544)
    ], 512),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([{ hidden: !_ctx.isOver }, "vis-bottom"])
    }, [
      (_ctx.isBusy)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(_component_imdex_spinner, {
              size: "2",
              width: "15"
            }),
            _hoisted_22
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottomButtons, (btn, i) => {
          return (_openBlock(), _createBlock(_component_imdex_tooltip, {
            nudgeY: -10,
            key: i
          }, {
            activator: _withCtx((on) => [
              _createElementVNode("div", _mergeProps({
                onClick: btn.action
              }, _toHandlers(on), {
                class: [{
								'grid-inactive':
									(btn.icon == 'grid' && !_ctx.gridOn) ||
									(btn.icon == 'cube' && _ctx.perspectiveOn)
							}, "vis-btn"]
              }), [
                _createElementVNode("img", {
                  src: _ctx.$data[btn.icon]
                }, null, 8, _hoisted_25)
              ], 16, _hoisted_24)
            ]),
            tooltip: _withCtx(() => [
              _createElementVNode("span", {
                style: {"white-space":"nowrap"},
                innerHTML: btn.name
              }, null, 8, _hoisted_26)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
          activator: _withCtx((on) => [
            _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "z-scale-container" }), [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("input", {
                  type: "number",
                  contextmenu: "false",
                  value: _ctx.zScaling,
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changeZ($event)))
                }, null, 40, _hoisted_28)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: "z-control",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.incrementZ(1)))
                }, _hoisted_31),
                _createElementVNode("div", {
                  class: "z-control",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.incrementZ(-1)))
                }, _hoisted_33)
              ])
            ], 16)
          ]),
          tooltip: _withCtx(() => [
            _createElementVNode("span", {
              style: {"white-space":"nowrap"},
              innerHTML: _ctx.$t(`ssa.visualizer.3dView.zScalingFactor`)
            }, null, 8, _hoisted_34)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.toggleBackground && _ctx.toggleBackground(...args))),
          class: _normalizeClass([{ white: _ctx.light }, "toggle-background"])
        }, null, 2),
        _createVNode(_component_imdex_select, {
          style: {"max-width":"120px"},
          mini: "",
          value: _ctx.zType,
          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.zType) = $event)),
          items: [{ text: _ctx.$t(`ssa.visualizer.3dView.solid`), value: 'solid' }]
        }, null, 8, ["value", "items"])
      ])
    ], 2), [
      [_vShow, !_ctx.collapsed]
    ])
  ], 544))
}